var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-toolbar",
        {
          staticClass: "top-page-toolbar",
          attrs: { color: "white", "text-color": "grey-9" }
        },
        [
          _c(
            "q-toolbar-title",
            { staticClass: "q-body-2" },
            [
              _c(
                "router-link",
                {
                  staticClass: "text-grey-10 no-underline",
                  attrs: {
                    to: {
                      name: "expenses-dashboard",
                      params: { teamId: _vm.activeTeam.id }
                    }
                  }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$tc("expense", 2)) + "\n      "
                  )
                ]
              ),
              _vm._v("\n      / "),
              _c("span", { staticClass: "text-weight-bold" }, [
                _vm._v(_vm._s(_vm.$t("captured_expenses")))
              ])
            ],
            1
          ),
          _c(
            "q-btn",
            {
              attrs: { label: _vm.$t("filter"), icon: "filter_list", flat: "" }
            },
            [
              _vm.filterCount > 0
                ? _c("q-chip", { attrs: { color: "primary", floating: "" } }, [
                    _vm._v(_vm._s(_vm.filterCount))
                  ])
                : _vm._e(),
              _c(
                "q-popover",
                [
                  _c(
                    "q-list",
                    { attrs: { separator: "", link: "" } },
                    [
                      _c(
                        "q-item",
                        [
                          _c("q-item-side", {
                            attrs: { icon: "calendar_today" }
                          }),
                          _c(
                            "q-item-main",
                            [
                              _c("q-datetime", {
                                staticClass: "q-mr-lg",
                                attrs: {
                                  value: _vm.filter.InvoiceDateStart,
                                  type: "date",
                                  name: "filterInvoiceDateStart",
                                  placeholder: _vm.$t(
                                    "expense_filter_invoice_date_from"
                                  ),
                                  format: _vm.$t("date_format"),
                                  "hide-underline": "",
                                  clearable: ""
                                },
                                on: {
                                  change: function(val) {
                                    _vm.filter.InvoiceDateStart = val
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        [
                          _c("q-item-side", {
                            attrs: { icon: "calendar_today" }
                          }),
                          _c(
                            "q-item-main",
                            [
                              _c("q-datetime", {
                                attrs: {
                                  value: _vm.filter.InvoiceDateEnd,
                                  type: "date",
                                  name: "filterInvoiceDateEnd",
                                  placeholder: _vm.$t(
                                    "expense_filter_invoice_date_to"
                                  ),
                                  format: _vm.$t("date_format"),
                                  "hide-underline": "",
                                  clearable: ""
                                },
                                on: {
                                  change: function(val) {
                                    _vm.filter.InvoiceDateEnd = val
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "q-item",
                        { attrs: { link: "", tag: "label" } },
                        [
                          _c("q-item-side", { attrs: { icon: "payment" } }),
                          _c(
                            "q-item-main",
                            [
                              _c("q-select", {
                                attrs: {
                                  options: _vm.paidFilterOptions,
                                  placeholder: _vm.$t("expense_filter_payment"),
                                  "hide-underline": "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.isPaid,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "isPaid", $$v)
                                  },
                                  expression: "filter.isPaid"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("q-btn", {
            attrs: { label: _vm.$t("export"), flat: "", size: "md" },
            nativeOn: {
              click: function($event) {
                return _vm.handleExport($event)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "layout-padding" },
        [
          !_vm.expensesLoaded
            ? _c(
                "div",
                { staticClass: "row justify-center" },
                [_c("q-spinner")],
                1
              )
            : _vm.expensesLoaded && _vm.expenses.length
              ? _c(
                  "q-infinite-scroll",
                  { attrs: { handler: _vm.handleFetchNextChunk } },
                  _vm._l(_vm.groupedExpenses, function(expenses, key) {
                    return _c("div", { key: key }, [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "q-subheading text-bold text-blue-grey-4 q-mt-lg q-mb-sm",
                          staticStyle: { "line-height": "initial" }
                        },
                        [_vm._v("\n          " + _vm._s(key) + "\n        ")]
                      ),
                      _c(
                        "div",
                        { staticClass: "row" },
                        [_c("expense-list", { attrs: { expenses: expenses } })],
                        1
                      )
                    ])
                  })
                )
              : _c("div", { staticClass: "flex column text-center" }, [
                  _c("img", {
                    attrs: {
                      src: require("assets/emptystates/items_empty.svg")
                    }
                  }),
                  _c("h6", { staticClass: "q-my-md text-faded" }, [
                    _vm._v(_vm._s(_vm.$t("no_expenses")))
                  ]),
                  _c(
                    "div",
                    [
                      _c(
                        "q-btn",
                        {
                          directives: [
                            { name: "is-user", rawName: "v-is-user" }
                          ],
                          staticClass: "q-mt-lg",
                          attrs: { color: "primary", outline: "" },
                          on: {
                            click: function($event) {
                              _vm.$router.push({
                                name: "expenses-dashboard",
                                params: { teamId: _vm.activeTeam.id }
                              })
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("back_to_expense_dashboard")) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
        ],
        1
      ),
      _c("expense-export-modal", { ref: "exportExpenseModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }